import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import MenuDesktopSettings from '../../components/menuSettings/desktop'
import MenuMobileSettings from '../../components/menuSettings/mobile'
import { NavBarCollapsableContext } from '../../helpers/context'
import { useWindowSize } from '../../helpers/hooks/hookWindowsSize'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Profile from './profile'
import AccountDetails from './accountDetails'

const Settings = () => {
  const { t } = useTranslation()
  const classContext = useContext(NavBarCollapsableContext)
  const [selectedOption, setSelectedOption] = useState('PROFILE')
  const [showMenuMobile, setShowMenuMobile] = useState(true)
  const sizeWidth = useWindowSize().width

  const handleOptionClick = (option: string) => {
    setSelectedOption(option)
    setShowMenuMobile(false)
  }

  const MenuOption = () => {
    return (
      <div
        className="container-menu-option-mobile"
        onClick={() => setShowMenuMobile(!showMenuMobile)}
      >
        <span className="title-setting">{`${t(selectedOption)}`}</span>
        {showMenuMobile ? (
          <FontAwesomeIcon icon={faChevronUp} />
        ) : (
          <FontAwesomeIcon icon={faChevronDown} />
        )}
      </div>
    )
  }
  return (
    <>
      <div className={`container-home-settings`}>
        <div className={classContext.classes.navbar_padding_left}>
          <div className="container-settings">
            {sizeWidth > 768 ? (
              <MenuDesktopSettings handleOptionClick={handleOptionClick} />
            ) : (
              showMenuMobile && (
                <MenuMobileSettings handleOptionClick={handleOptionClick} />
              )
            )}

            <div className="content-settings">
              {sizeWidth < 768 && <MenuOption />}
              {selectedOption && (
                <div>
                  {selectedOption === 'PROFILE' && <Profile />}

                  {selectedOption === 'ACCOUNT_DETAILS' && <AccountDetails/>}
                  {selectedOption === 'BILLING_AND_USAGE' && (
                    <p>billing-and-usage</p>
                  )}
                  {selectedOption === 'CUSTOM_DOMAINS' && <p>custom-domains</p>}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Settings
